// Generated by purs version 0.15.15
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_FormURLEncoded from "../Data.FormURLEncoded/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Now from "../Effect.Now/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Form_Widgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic_Form_Widgets_Bootstrap from "../Restaumatic.Form.Widgets.Bootstrap/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic_Services_Storage_LocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic_Site_Routes from "../Restaumatic.Site.Routes/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Dom_Widget from "../Specular.Dom.Widget/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_FormField_Extra from "../Specular.FormField.Extra/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_Dom_Builder.bindBuilder);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Specular_Dom_Builder.bindBuilder);
var hasErrorsWithId = /* #__PURE__ */ Restaumatic_Form_Internal.hasErrorsWithId(Restaumatic_Form_Internal.hasErrorsOldFormField);
var hasLabelWithId = /* #__PURE__ */ Restaumatic_Form_Internal.hasLabelWithId(Restaumatic_Form_Internal.hasLabelFormField);
var dateTimeLocalField = /* #__PURE__ */ Restaumatic_Form_Widgets_Bootstrap.dateTimeLocalField(/* #__PURE__ */ Restaumatic_Form_Internal.isRefLikeWithId(Restaumatic_Form_Internal.isRefLikeFormField))(hasErrorsWithId)(Restaumatic_Form_Widgets.asDateTimeMaybeDateTime)(Restaumatic_Form_Widgets_Bootstrap.labelString)(hasLabelWithId)(Restaumatic_Form_Internal.hasFieldIdWithId)()();
var isTextFieldWithId = /* #__PURE__ */ Restaumatic_Form_Internal.isTextFieldWithId(Restaumatic_Form_Internal.isTextFieldFormFieldStrin);
var textField = /* #__PURE__ */ Restaumatic_Form_Widgets_Bootstrap.textField(hasErrorsWithId)(Restaumatic_Form_Widgets_Bootstrap.labelString)(isTextFieldWithId)(hasLabelWithId)(Restaumatic_Form_Internal.hasFieldIdWithId)()();
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringProp);
var textAreaField = /* #__PURE__ */ Restaumatic_Form_Widgets_Bootstrap.textAreaField(hasErrorsWithId)(Restaumatic_Form_Widgets_Bootstrap.labelString)(isTextFieldWithId)(hasLabelWithId)(Restaumatic_Form_Internal.hasFieldIdWithId)()();
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var identity1 = /* #__PURE__ */ Control_Category.identity(Specular_FormField.categoryConversion);
var rawHtml = /* #__PURE__ */ Specular_Dom_Builder_Class.rawHtml(Specular_Dom_Builder.monadDomBuilderBuilder);
var monadFRP = /* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder);
var withDynamic_ = /* #__PURE__ */ Specular_FRP_Replaceable.withDynamic_(Specular_Dom_Builder.monadReplaceBuilder)(monadFRP);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Tuple.functorTuple);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Aff.monadEffectAff);
var queryFormFieldPartial = /* #__PURE__ */ Restaumatic_Form_Query.queryFormFieldPartial(Type_Equality.refl);
var query = /* #__PURE__ */ Restaumatic_Form_Query.query(/* #__PURE__ */ Restaumatic_Form_Query.queryRecord(Restaumatic_Form_Internal.asRecordRecord)()(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "email";
    }
})(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "fullName";
    }
})(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "info";
    }
})(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "numPeople";
    }
})(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "phone";
    }
})(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "reservationDate";
    }
})(/* #__PURE__ */ Restaumatic_Form_Query.queryRecordCons({
    reflectSymbol: function () {
        return "restaurantSlug";
    }
})(Restaumatic_Form_Query.queryRecordNilTotal)(/* #__PURE__ */ Restaumatic_Form_Query.queryFinalPartial(Type_Equality.refl))()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()())(queryFormFieldPartial)()()()()()));
var merge = /* #__PURE__ */ Record.merge()();
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect_Aff.applicativeAff)(Data_Foldable.foldableMaybe);
var liftEffect1 = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Aff.monadEffectAff);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder);
var holdDyn = /* #__PURE__ */ Specular_FRP_Base.holdDyn(monadFRP);
var map2 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorEvent);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder);
var phoneKey = "reservation:phone";
var numPeopleKey = "reservation:numPeople";
var infoKey = "reservation:info";
var fullNameKey = "reservation:fullName";
var formView = function (form) {
    return bind(liftEffect(Effect_Now.nowDateTime))(function (now) {
        return discard1(dateTimeLocalField({
            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.reservation_date.label),
            min: new Data_Maybe.Just(now),
            field: Restaumatic_Form_Internal.withId("reservationDate")(form.reservationDate)
        }))(function () {
            return discard1(textField({
                label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.num_people.label),
                field: Restaumatic_Form_Internal.withId("numPeople")(form.numPeople),
                props: [ attr("type")("number"), attr("min")("1") ]
            }))(function () {
                return discard1(textField({
                    label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.phone.label),
                    field: Restaumatic_Form_Internal.withId("phone")(form.phone)
                }))(function () {
                    return discard1(textField({
                        label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.email.label),
                        field: Restaumatic_Form_Internal.withId("email")(form.email)
                    }))(function () {
                        return discard1(textField({
                            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.full_name.label),
                            field: Restaumatic_Form_Internal.withId("fullName")(form.fullName)
                        }))(function () {
                            return discard1(textAreaField({
                                label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.user_notes.label),
                                field: Restaumatic_Form_Internal.withId("info")(form.info)
                            }))(function () {
                                return Specular_Dom_Element.el("button")([ Specular_Dom_Element.attr("type")("submit"), Specular_Dom_Element.class_("button"), Specular_Dom_Element.onClick_(form.submit) ])(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.form.submit)));
                            });
                        });
                    });
                });
            });
        });
    });
};
var emailKey = "reservation:email";
var initForm = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind2 = Control_Bind.bind(Monad0.Bind1());
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect2 = Effect_Class.liftEffect(MonadEffect0);
    var newPersistentFormFieldE = Specular_FormField_Extra.newPersistentFormFieldE(dictMonadFRP)(Foreign_Generic_Class.stringDecode)(Foreign_Generic_Class.stringEncode);
    var newPersistentFormField = Specular_FormField_Extra.newPersistentFormField(dictMonadFRP)(Foreign_Generic_Class.stringDecode)(Foreign_Generic_Class.stringEncode);
    var newFormField = Specular_FormField.newFormField(dictMonadFRP);
    var $$new = Specular_Ref["new"](MonadEffect0);
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    var wordRE = Data_Either_Extra.fromRightWith(function (e) {
        return Partial_Unsafe.unsafeCrashWith(show(e));
    })(Data_String_Regex.regex("\\s+")(Data_String_Regex_Flags.noFlags));
    var words = Data_String_Regex.split(wordRE);
    var minTwoWordConversion = {
        fromInitial: identity,
        toFinal: function (x) {
            var $169 = length(Data_Array.filter(function (v) {
                return v !== "";
            })(words(x))) >= 2;
            if ($169) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.activerecord.errors.models.user.attributes.full_name.invalid) ]);
        }
    };
    return bind2(Specular_FRP_Base.newEvent(MonadEffect0))(function (submit) {
        return bind2(liftEffect2(Effect_Now.nowDateTime))(function (now) {
            var positiveIntConversionErrs = {
                positiveIntError: Restaumatic_I18n.translate(Restaumatic_Site_Translations_Keys.t.errors.messages.greater_than)({
                    count: "0"
                }),
                intError: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.errors.messages.not_a_number)
            };
            var formState = {
                submitOccured: submit.event,
                remoteErrors: pure1(Data_Map_Internal.empty)
            };
            return bind2(newPersistentFormFieldE(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(emailKey)(Specular_FormField.emailConversion(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.validations.invalid_email)))(Specular_FormField.fieldStateEmpty(formState))(""))(function (emailField) {
                return bind2(newPersistentFormFieldE(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(phoneKey)(Specular_FormField.phoneConversion(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.validations.invalid_phone)))(Specular_FormField.fieldStateEmpty(formState))(""))(function (phoneField) {
                    return bind2(newPersistentFormFieldE(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(numPeopleKey)(Specular_FormField.positiveIntConversion(positiveIntConversionErrs))(Specular_FormField.fieldStateEmpty(formState))(""))(function (numPeople) {
                        return bind2(newPersistentFormField(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(fullNameKey)(minTwoWordConversion)(Specular_FormField.fieldStateEmpty(formState))(""))(function (fullName) {
                            return bind2(newPersistentFormField(Restaumatic_Services_Storage_LocalStorageNoFallback.localStorageNoFallback)(infoKey)(identity1)(Specular_FormField.fieldStateEmpty(formState))(""))(function (info) {
                                return bind2(newFormField(Specular_FormField.maybeConversion(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.validations.enter_date)))(Specular_FormField.fieldStateEmpty(formState))(now))(function (reservationDate) {
                                    return bind2($$new(false))(function (success) {
                                        return pure3({
                                            email: emailField,
                                            phone: phoneField,
                                            numPeople: numPeople,
                                            fullName: fullName,
                                            info: info,
                                            reservationDate: reservationDate,
                                            submit: submit.fire(Data_Unit.unit),
                                            submitEvent: submit.event,
                                            success: success
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    });
};
var displaySuccess = /* #__PURE__ */ Specular_Dom_Element.el("div")([ /* #__PURE__ */ Specular_Dom_Element.class_("alert alert-success") ])(/* #__PURE__ */ discard1(/* #__PURE__ */ Specular_Dom_Element.el("span")([ /* #__PURE__ */ Specular_Dom_Element.class_("icon-ok icon-green"), /* #__PURE__ */ Specular_Dom_Element.attr("aria-hidden")("true") ])(Restaumatic_Prelude_Specular.wempty))(function () {
    return discard1(rawHtml("&nbsp;"))(function () {
        return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.theme_defaults.reservation.success_message));
    });
}));
var view = function (form) {
    return withDynamic_(Specular_Ref.value(form.success))(function (v) {
        if (v) {
            return displaySuccess;
        };
        return formView(form);
    });
};
var control = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var initForm1 = initForm(dictMonadFRP);
    var discard2 = discard(Bind1);
    var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(MonadCleanup1);
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (dynRestaurantSlug) {
        var isOk = function (v) {
            if (v instanceof Data_Either.Right) {
                return v.value0.status >= 200 && v.value0.status < 300;
            };
            if (v instanceof Data_Either.Left) {
                return false;
            };
            throw new Error("Failed pattern match at Restaumatic.Site.Components.Reservation (line 218, column 3 - line 218, column 71): " + [ v.constructor.name ]);
        };
        var formatRequest = function (request) {
            return Data_FormURLEncoded.fromArray(map(map1(Data_Maybe.Just.create))([ new Data_Tuple.Tuple("table_reservation[restaurant_slug]", request.restaurantSlug), new Data_Tuple.Tuple("table_reservation[reservation_date]", DateUtils.formatISODateTime(request.reservationDate)), new Data_Tuple.Tuple("table_reservation[num_people]", show1(request.numPeople)), new Data_Tuple.Tuple("table_reservation[full_name]", request.fullName), new Data_Tuple.Tuple("table_reservation[email]", request.email), new Data_Tuple.Tuple("table_reservation[phone]", request.phone), new Data_Tuple.Tuple("table_reservation[info]", request.info) ]));
        };
        return bind2(initForm1)(function (form) {
            return discard2(Data_Function.flip(subscribeEvent_)(form.submitEvent)(function (v) {
                return Effect_Aff.launchAff_(bind1(readDynamic(Restaumatic_Form_Final.unFinal(query(merge(form)({
                    restaurantSlug: Restaumatic_Form_Final.makeFinal(dynRestaurantSlug)
                })))))(function (v1) {
                    return for_(v1)(function (request) {
                        return bind1(liftEffect1(Restaumatic_Site_Routes.reservationPath))(function (path) {
                            return bind1(Affjax_Web.post(Affjax_ResponseFormat.json)(path)(new Data_Maybe.Just(new Affjax_RequestBody.FormURLEncoded(formatRequest(request)))))(function (response) {
                                return write(form.success)(isOk(response));
                            });
                        });
                    });
                }));
            }))(function () {
                return pure3(form);
            });
        });
    };
};
var control1 = /* #__PURE__ */ control(monadFRP);
var run = function (cfg) {
    return Specular_Dom_Widget.runMainWidgetInNode(cfg.container)(bind(newEvent)(function (e) {
        return bind(holdDyn(Data_Maybe.Nothing.value)(map2(Data_Maybe.Just.create)(e.event)))(function (dyn) {
            return discard1(bind(control1(dyn))(view))(function () {
                return pure2({
                    selectedRestaurantSlug: e.fire
                });
            });
        });
    }));
};
export {
    run
};
